import { standardBlueprint } from './standardBlueprint';

export const standardBlueprintVersion = '0.0.0';

export const blueprintVersionMap = new Map([
  [standardBlueprintVersion, standardBlueprint],
]);
